import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massDestroyAgencies } from '../../api/apiAgencies';
import toast from 'react-hot-toast';

export const useMassDestroyAgencies = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massDestroyAgencies,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['agencies'] });
            toast.success(data.message || 'Agencies deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete agencies';
            toast.error(errorMessage);
        },
    });
};
